import { HttpService } from '@services/http-service';
import { ChartService } from '@services/webFeeder/sckt-chart.service';
import { NotificationsService } from 'angular2-notifications';
import { Subscription , of } from 'rxjs';
import { environment } from './../../../environments/environment';
import {
  Component, Input, OnDestroy, HostListener, Output, EventEmitter, AfterViewInit,
  ChangeDetectorRef, ViewChild, ElementRef, OnInit
} from '@angular/core';
import { ConfigService } from '@services/webFeeder/config.service';
import { AutoLogoutService } from '@auth/auto-logout-service.service';
import { ActivatedRoute } from '@angular/router';

import * as moment from 'moment';
import { WebFeederFactory } from '@connections/web-feeder.factory';
import { Constants } from '@utils/constants';
import { ChartingLibraryWidgetOptions, IChartingLibraryWidget, widget, LanguageCode } from 'src/assets/charting_library_old/charting_library.min';

@Component({
  selector: 'app-trading-view',
  templateUrl: './trading-view.component.html'
})
export class TradingViewComponent implements OnInit, OnDestroy, AfterViewInit {
  private _symbol: ChartingLibraryWidgetOptions['symbol'] = Constants.BLANK_CHART;
  private _interval: ChartingLibraryWidgetOptions['interval'] = '15';
  private _timeframe: ChartingLibraryWidgetOptions['timeframe'] = '1D';
  private _datafeedUrl = environment.LOGIN_TYPE === 'LoginW' || environment.LOGIN_TYPE === 'LoginA'
    ? this.configService.getApiNodeCandleRequest() + '/services/TradingView' : this.configService.getApiNodeCandleRequest() + '/services/chart';
  private _libraryPath: ChartingLibraryWidgetOptions['library_path'] = './assets/charting_library_old/';
  private _clientId: ChartingLibraryWidgetOptions['client_id'] = 'tradingview.com';
  private _userId: ChartingLibraryWidgetOptions['user_id'];
  private _fullscreen: ChartingLibraryWidgetOptions['fullscreen'] = false;
  private _autosize: ChartingLibraryWidgetOptions['autosize'] = true;
  public _containerId: ChartingLibraryWidgetOptions['container_id'] = 'tv-chart-container-';
  private _tvWidget: IChartingLibraryWidget | null = null;
  private subscriptions: Array<Subscription> = [];
  private _chartService: ChartService;
  private _isMobileWebView: boolean;
  private _customToken: string = null;
  private _chartLastStatus: any;
  private _firstLoad = true;
  private _saveChartUrl: string;
  private _newlyChangedSymbol = false;
  private _usersbrokerName: string = null;
  private _saveChartTimeout: any;
  private _input: any;
  private _onlyOneSymbolChange = true;
  private _validActive = false;
  private firstSymbolChange = false;
  private chartCreated = false;
  private isInWorkspace = true;

  @ViewChild('chartWrapper') chartWrapper: ElementRef<HTMLDivElement>;

  @Input()
  set customToken(customToken: string) {
    this._customToken = customToken || this._customToken;
  }

  @Input()
  set symbol(symbol: ChartingLibraryWidgetOptions['symbol']) {
    if (!symbol) {
      setTimeout(() => {
        this.currentSymbol.emit(this._symbol);
      });
    } else if (this._chartService.getRegisteredSymbols(symbol)) {
      this.notificationService.error('Erro', Constants.WORKSPACE_MSG015);
      setTimeout(() => {
        this._symbol = Constants.BLANK_CHART;
        this.currentSymbol.emit(this._symbol);
      }, 0);
    } else {
      this._symbol = symbol;
      if (!this.firstSymbolChange && this.chartCreated) {
        let newSymbol = symbol;
        if (this._chartService.getRegisteredSymbols(symbol)) {
          newSymbol = Constants.BLANK_CHART;
        }
        this.currentSymbol.next(newSymbol);
        this.loadChart();
      }
    }
  }

  @Input()
  set interval(interval: ChartingLibraryWidgetOptions['interval']) {
    this._interval = interval || this._interval;
  }

  @Input()
  set timeframe(timeframe: ChartingLibraryWidgetOptions['timeframe']) {
    this._timeframe = timeframe || this._timeframe;
  }

  @Input()
  set datafeedUrl(datafeedUrl: string) {
    this._datafeedUrl = datafeedUrl || this._datafeedUrl;
  }

  @Input()
  set libraryPath(libraryPath: ChartingLibraryWidgetOptions['library_path']) {
    this._libraryPath = libraryPath || this._libraryPath;
  }

  @Input()
  set clientId(clientId: ChartingLibraryWidgetOptions['client_id']) {
    this._clientId = clientId || this._clientId;
  }

  @Input()
  set userId(userId: ChartingLibraryWidgetOptions['user_id']) {
    this._userId = userId || this._userId;
  }

  @Input()
  set fullscreen(fullscreen: ChartingLibraryWidgetOptions['fullscreen']) {
    this._fullscreen = fullscreen || this._fullscreen;
  }

  @Input()
  set autosize(autosize: ChartingLibraryWidgetOptions['autosize']) {
    this._autosize = autosize || this._autosize;
  }

  @Input()
  set containerId(containerId: ChartingLibraryWidgetOptions['container_id']) {
    this._containerId = containerId || this._containerId;
  }

  @Input() parentComponent = 'tv-full-heigth';

  @Output() currentSymbol = new EventEmitter<string>();

  @HostListener('mousemove')
  onMouseMove() {
    this._autoLogoutService.resetTime();
  }

  @HostListener('click')
  onClick() {
    this._autoLogoutService.resetTime();
  }

  constructor(
    private configService: ConfigService,
    private _autoLogoutService: AutoLogoutService,
    private route: ActivatedRoute,
    private notificationService: NotificationsService,
    private chartService: ChartService,
    private cd: ChangeDetectorRef,
    private _httpService: HttpService,
  ) {
    this._chartService = chartService;
  }

  ngOnInit() {
    if (!this._userId) {
      const userTemp = this.configService.getUserMarketData();
      this._userId = userTemp ? userTemp.login : this.configService.getHbAccount();
      if (!this._userId || this._userId === 'undefined') {
        const hbaCurrentUser = this.configService.getHbCurrentUser();
        this._userId = hbaCurrentUser ? hbaCurrentUser.username : null;
      }
    }
    this._saveChartUrl = this.configService.getSaveChartUrl();
  }

  ngAfterViewInit() {
    let customContainerId;
    this.isInWorkspace = true;
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      if (params['symbol']) {
        this._symbol = params['symbol'].toUpperCase();
        customContainerId = params['chartid'];
        this.currentSymbol.next(this._symbol);
        this._isMobileWebView = params['wv'] === 'true' ? true : false;
        this._userId = params['user'] ? params['user'] : this._userId;
        this._usersbrokerName = params['broker'];
        this.isInWorkspace = false;
      } else {
        const wlConfig = this.configService.getConfigWhitelabel();
        const multibrokerConfig = this.configService.getConfigMultibroker();
        if (wlConfig && wlConfig.system && wlConfig.system.isMultiBroker && multibrokerConfig && multibrokerConfig.usersBrokerName) {
          this._usersbrokerName = multibrokerConfig.usersBrokerName;
        }

        const location = window.location;
        if (location) {
          this.isInWorkspace = !(location.pathname === '/chart' || location.pathname === environment.BASE_HREF + '/chart');
        }
      }
      this._containerId = customContainerId ? this._containerId + customContainerId : this._containerId + this._chartService.getNewChartId();

      this.configService.setSymbolInformation({
        chartId: this._containerId, symbolName: '', symbolInfo: {},
        isInWorkspace: this.isInWorkspace, invalidSymbol: false
      });

      this.cd.detectChanges();
      this.chartCreated = true;
      if (this._userId && this._userId !== 'undefined') {
        this.loadChart();
      } else {
        this.createChartConfig();
      }
    }));
  }

  createChartConfig() {
    const url_ws_chart = this._customToken && this._customToken !== '' ? this.configService.getUrlWebSocketWebFeeder(1, true, this._customToken) : null;
    const web_feeder_factory = this._customToken && this._customToken !== '' ? WebFeederFactory : null;
    const theme = window.sessionStorage.getItem(Constants.LAYOUT_THEME_DARK) === 'true' ? 'dark' : 'light';
    const bodyStyles = window.getComputedStyle(document.body);
    const upColor = bodyStyles.getPropertyValue(`--color-${theme}-candlestick-high`).trim();
    const downColor = bodyStyles.getPropertyValue(`--color-${theme}-candlestick-low`).trim();
    const bgColor = bodyStyles.getPropertyValue(`--color-${theme}-candlestick-bg`).trim();
    let studies_overrides: any;
    let overrides: any;
    let chartPropertiesTemp: any;
    let elementSourcesTemp: any;
    if (this._chartLastStatus && this._chartLastStatus.charts) { // API CHART
      this._chartLastStatus.charts.forEach(elementCharts => {
        if (elementCharts.chartProperties) {
          chartPropertiesTemp = {
            'scalesProperties.backgroundColor': elementCharts.chartProperties.scalesProperties ? elementCharts.chartProperties.scalesProperties.backgroundColor : bgColor,
            'scalesProperties.lineColor': elementCharts.chartProperties.scalesProperties ? elementCharts.chartProperties.scalesProperties.lineColor : null,
            'scalesProperties.textColor': elementCharts.chartProperties.scalesProperties ? elementCharts.chartProperties.scalesProperties.textColor : null,
            'paneProperties.background': elementCharts.chartProperties.paneProperties ? elementCharts.chartProperties.paneProperties.background : bgColor,
            'paneProperties.crossHairProperties.color':
              elementCharts.chartProperties.paneProperties ? elementCharts.chartProperties.paneProperties.crossHairProperties.color : null,
            'paneProperties.gridProperties.color': elementCharts.chartProperties.paneProperties ? elementCharts.chartProperties.paneProperties.gridProperties.color : null,
            'paneProperties.horzGridProperties.color': elementCharts.chartProperties.paneProperties ? elementCharts.chartProperties.paneProperties.horzGridProperties.color : null,
            'paneProperties.vertGridProperties.color': elementCharts.chartProperties.paneProperties ? elementCharts.chartProperties.paneProperties.vertGridProperties.color : null,
            'paneProperties.scalesProperties.lineColor': elementCharts.chartProperties.scalesProperties ? elementCharts.chartProperties.scalesProperties.lineColor : null,
            'paneProperties.scalesProperties.textColor': elementCharts.chartProperties.scalesProperties ? elementCharts.chartProperties.scalesProperties.textColor : null,
          };
        }
        if (elementCharts.panes) {
          elementCharts.panes.forEach(elementPanes => {
            if (elementPanes.sources) {
              elementPanes.sources.forEach(elementSources => {
                if (elementSources.type && elementSources.type.toLowerCase() === 'mainseries') {
                  elementSourcesTemp = {
                    'mainSeriesProperties.candleStyle.upColor': elementSources.state.candleStyle.upColor,
                    'mainSeriesProperties.candleStyle.downColor': elementSources.state.candleStyle.downColor,
                    'mainSeriesProperties.candleStyle.borderColor': elementSources.state.candleStyle.borderColor,
                    'mainSeriesProperties.candleStyle.borderUpColor': elementSources.state.candleStyle.borderUpColor,
                    'mainSeriesProperties.candleStyle.borderDownColor': elementSources.state.candleStyle.borderDownColor,
                    'mainSeriesProperties.candleStyle.wickColor': elementSources.state.candleStyle.wickColor,
                    'mainSeriesProperties.candleStyle.wickUpColor': elementSources.state.candleStyle.wickUpColor,
                    'mainSeriesProperties.candleStyle.wickDownColor': elementSources.state.candleStyle.wickDownColor,
                    'mainSeriesProperties.hollowCandleStyle.upColor': elementSources.state.hollowCandleStyle.upColor,
                    'mainSeriesProperties.hollowCandleStyle.downColor': elementSources.state.hollowCandleStyle.downColor,
                    'mainSeriesProperties.hollowCandleStyle.borderColor': elementSources.state.hollowCandleStyle.borderColor,
                    'mainSeriesProperties.hollowCandleStyle.borderUpColor': elementSources.state.hollowCandleStyle.borderUpColor,
                    'mainSeriesProperties.hollowCandleStyle.borderDownColor': elementSources.state.hollowCandleStyle.borderDownColor,
                    'mainSeriesProperties.hollowCandleStyle.wickColor': elementSources.state.hollowCandleStyle.wickColor,
                    'mainSeriesProperties.hollowCandleStyle.wickUpColor': elementSources.state.hollowCandleStyle.wickUpColor,
                    'mainSeriesProperties.hollowCandleStyle.wickDownColor': elementSources.state.hollowCandleStyle.wickDownColor,
                    'mainSeriesProperties.haStyle.upColor': elementSources.state.haStyle.upColor,
                    'mainSeriesProperties.haStyle.downColor': elementSources.state.haStyle.downColor,
                    'mainSeriesProperties.haStyle.borderColor': elementSources.state.haStyle.borderColor,
                    'mainSeriesProperties.haStyle.borderUpColor': elementSources.state.haStyle.borderUpColor,
                    'mainSeriesProperties.haStyle.borderDownColor': elementSources.state.haStyle.borderDownColor,
                    'mainSeriesProperties.haStyle.wickColor': elementSources.state.haStyle.wickColor,
                    'mainSeriesProperties.haStyle.wickUpColor': elementSources.state.haStyle.wickUpColor,
                    'mainSeriesProperties.haStyle.wickDownColor': elementSources.state.haStyle.wickDownColor,
                    'mainSeriesProperties.barStyle.upColor': elementSources.state.barStyle.upColor,
                    'mainSeriesProperties.barStyle.downColor': elementSources.state.barStyle.downColor,
                    'mainSeriesProperties.hiloStyle.color': elementSources.state.hiloStyle.color,
                    'mainSeriesProperties.hiloStyle.borderColor': elementSources.state.hiloStyle.borderColor,
                    'mainSeriesProperties.hiloStyle.labelColor': elementSources.state.hiloStyle.labelColor,
                    'mainSeriesProperties.lineStyle.color': elementSources.state.lineStyle.color,
                    'mainSeriesProperties.areaStyle.color1': elementSources.state.areaStyle.color1,
                    'mainSeriesProperties.areaStyle.color2': elementSources.state.areaStyle.color2,
                    'mainSeriesProperties.areaStyle.linecolor': elementSources.state.areaStyle.linecolor,
                    'mainSeriesProperties.baselineStyle.baselineColor': elementSources.state.baselineStyle.baselineColor,
                    'mainSeriesProperties.baselineStyle.topFillColor1': elementSources.state.baselineStyle.topFillColor1,
                    'mainSeriesProperties.baselineStyle.topFillColor2': elementSources.state.baselineStyle.topFillColor2,
                    'mainSeriesProperties.baselineStyle.bottomFillColor1': elementSources.state.baselineStyle.bottomFillColor1,
                    'mainSeriesProperties.baselineStyle.bottomFillColor2': elementSources.state.baselineStyle.bottomFillColor2,
                    'mainSeriesProperties.baselineStyle.topLineColor': elementSources.state.baselineStyle.topLineColor,
                    'mainSeriesProperties.baselineStyle.bottomLineColor': elementSources.state.baselineStyle.bottomLineColor,
                    'mainSeriesProperties.interval': elementSources.state.interval,
                    'mainSeriesProperties.showCountdown': true,
                    'scalesProperties.showStudyLastValue': true,
                    'paneProperties.topMargin': 20,
                  };
                } else if (elementSources.type && elementSources.type.toLowerCase() === 'study') {
                  studies_overrides = elementSources;
                }
              });
            }
          });
        }
        overrides = Object.assign(chartPropertiesTemp, elementSourcesTemp);
      });
    } else { // DEFAULT
      overrides = {
        'mainSeriesProperties.candleStyle.upColor': upColor,
        'mainSeriesProperties.candleStyle.downColor': downColor,
        'mainSeriesProperties.candleStyle.wickUpColor': this.configService.getFavoriteThemeUser() ? '#ffffff' : '#5e5d58',
        'mainSeriesProperties.candleStyle.wickDownColor': this.configService.getFavoriteThemeUser() ? '#ffffff' : '#5e5d58',
        'mainSeriesProperties.candleStyle.borderUpColor': upColor,
        'mainSeriesProperties.candleStyle.borderDownColor': downColor,
        'mainSeriesProperties.showCountdown': true,
        'scalesProperties.showStudyLastValue': true,
        'scalesProperties.backgroundColor': bgColor,
        'paneProperties.topMargin': 20,
        'paneProperties.background': bgColor,
      };
    }
    const featuresToDisable = [
      'use_localstorage_for_settings', 'header_saveload', 'header_compare', 'study_templates',
      'symbol_search_hot_key', 'show_interval_dialog_on_key_press', 'timeframes_toolbar'
    ];
    const featuresToEnable = [];

    if (this.parentComponent === 'tv-quote-chart') {
      featuresToDisable.push('legend_widget');
    }

    if (this._isMobileWebView) {
      featuresToDisable.push('header_symbol_search', 'legend_widget');
      featuresToEnable.push('hide_left_toolbar_by_default');
    }
    const widgetOptions: ChartingLibraryWidgetOptions = {
      datafeed: new (window as any).Datafeeds.UDFCompatibleDatafeed(
        this._datafeedUrl,
        null,
        this.configService,
        moment,
        this.notificationService,
        this._containerId,
        url_ws_chart,
        this._customToken,
        web_feeder_factory,
        this._chartService
      ),
      interval: this._interval,
      container_id: this._containerId,
      library_path: this._libraryPath,
      locale: this.getLanguageFromURL(),
      disabled_features: featuresToDisable,
      enabled_features: featuresToEnable,
      client_id: this._clientId,
      user_id: this._userId,
      fullscreen: this._fullscreen,
      autosize: this._autosize,
      // theme: this.configService.getFavoriteThemeUser() ? 'Dark' : 'Light',
      timezone: 'America/Sao_Paulo',
      timeframe: this._timeframe,
      overrides,
      studies_overrides,
      time_frames: [
        { text: '1y', resolution: 'W' },
        { text: '6m', resolution: 'W' },
        { text: '3m', resolution: '60' },
        { text: '1m', resolution: '30' },
        { text: '7D', resolution: '15' },
        { text: '1D', resolution: '5' },
      ],
      auto_save_delay: 0.5,
      custom_css_url: './../../../assets/styles/tradingview/styles.css'
    };
    if (this._chartLastStatus) {
      widgetOptions.saved_data = this._chartLastStatus;
    } else {
      const tempSymbol = this._symbol.trim() === '' ? Constants.BLANK_CHART : this._symbol;
      widgetOptions.symbol = tempSymbol;
    }
    const tvWidget = new widget(widgetOptions);
    this._tvWidget = tvWidget;

    setTimeout(() => {
      this._tvWidget.onChartReady(() => {
        const themeCode = widgetOptions.theme === 'Dark' ? 1 : 2;
        this.changeChartTheme(themeCode);
        // TODO: Ativado salvar estudos do gráficos
        // this._tvWidget.chart().removeAllStudies();
        const themeChangeSubscription = this.configService.changeThemeDarkLight$.subscribe(this.changeChartTheme.bind(this));

        this.subscriptions.push(themeChangeSubscription);
        this.applyCustomStyle();
        if (this._symbol.trim() === Constants.BLANK_CHART.trim()) {
          this._chartService.subscriptionExcpetion();
        }
        const symbolObserver = this._tvWidget.chart().onSymbolChanged();
        symbolObserver.subscribe(obj => console.log(obj), () => {
          let canChange = true;
          if (this._input) {
            canChange = this._input.value.toLowerCase() !== this._symbol.toLowerCase();
          }
          console.log(this._input.value.toLowerCase())
          console.log(this._symbol.toLowerCase())
          console.log(canChange)
          if (canChange) {
            this._tvWidget.chart().setSymbol(this._input.value, () => { });
            this.symbolChange();
          }
        });
      });

      setTimeout(() => {
        if (this._userId && this._tvWidget) {
          this._tvWidget.subscribe('onAutoSaveNeeded', () => {
            setTimeout(() => {
              if (this._tvWidget) {
                const symbolInformation = this._tvWidget.chart().symbolExt();
                if (!symbolInformation) {
                  const tempSymbol = this._symbol.trim() === '' ? Constants.BLANK_CHART : this._symbol;
                  this.currentSymbol.emit(tempSymbol);
                } else if (symbolInformation.symbol !== this._symbol) {
                  this.currentSymbol.emit(symbolInformation.symbol);
                }

                if (this._saveChartTimeout) {
                  clearTimeout(this._saveChartTimeout);
                }
                this._saveChartTimeout = setTimeout(this.saveChart.bind(this), (this._newlyChangedSymbol ? 0 : 1000));
              }
            }, 1000);
          });
        }
      }, 1000);

      setTimeout(() => {
        const iframe = this.chartWrapper.nativeElement.getElementsByTagName('iframe')[0];
        if (iframe) {
          this._input = iframe.contentDocument.getElementsByTagName('input')[0];

          if (this._input) {
            this._input.addEventListener('focus', (event) => {
              this._input.value = this._input.value.trim();
            });
            if (!this._validActive) {
              this._input.focus();
            }

            this._input.addEventListener('change', (event) => {
              if (!this.isInWorkspace && this._symbol.trim() === '') {
                this._tvWidget.chart().setSymbol(this._input.value, () => { });
                this.symbolChange();
              }
            });
          }
        }

      }, 1000);
    }, 2000);
  }

  symbolChange() {
    if (this._onlyOneSymbolChange) {
      this._onlyOneSymbolChange = false;
      const completeSymbol = this._tvWidget.chart().symbol().split(':');
      const newSymbol = completeSymbol[completeSymbol.length - 1];
      if (completeSymbol && completeSymbol.length > 0 && newSymbol !== this._symbol && !this._chartService.getRegisteredSymbols(newSymbol)) {
        const oldSymbol = this._symbol.trim();
        const oldtInterval = this._tvWidget.chart().resolution();
        this.currentSymbol.next(newSymbol);
        this._symbol = newSymbol;
        this._newlyChangedSymbol = true;
        if (this._userId && this._userId !== 'undefined') {
          setTimeout(() => {
            this._chartService.unsubscribeChart(oldSymbol, oldtInterval);
            this.loadChart();
            this._onlyOneSymbolChange = true;
          }, 0);
        } else {
          setTimeout(() => {
            this._chartService.unsubscribeChart(oldSymbol, oldtInterval);
            this.createChartConfig();
            this._onlyOneSymbolChange = true;
          }, 0);
        }
      } else {
        let showError = true;
        const chartInformation = this.configService.getSymbolInformation();
        if (chartInformation && typeof (chartInformation) === 'string') {
          const chartInfoParsed = JSON.parse(chartInformation);
          if (chartInfoParsed && chartInfoParsed.length > 0) {
            const currentChart = chartInfoParsed.filter(x => x.chartId === this._containerId)[0];
            if (currentChart && currentChart.invalidSymbol !== undefined && currentChart.symbolInfo !== undefined
              && currentChart.invalidSymbol !== null && currentChart.symbolInfo !== null) {
              showError = currentChart.invalidSymbol;
              currentChart.invalidSymbol = false;
              currentChart.symbolInfo = currentChart.symbolName ? currentChart.symbolInfo : {};
              this.configService.setSymbolInformation(currentChart);
            }
          }
        }

        this._chartService.subscriptionExcpetion();
        if (showError) {
          this.notificationService.error('Erro', Constants.WORKSPACE_MSG015);
        }
        if (this._userId && this._userId !== 'undefined') {
          setTimeout(() => {
            this.loadChart();
            this._onlyOneSymbolChange = true;
          }, 0);
        } else {
          setTimeout(() => {
            this.createChartConfig();
            this._onlyOneSymbolChange = true;
          }, 0);
        }
      }
    }
  }

  applyCustomStyle() {
    const iframe = this.chartWrapper.nativeElement.getElementsByTagName('iframe')[0];
    let iframeHtmlElement: any;
    const cssLink = document.createElement('link');
    cssLink.href = `${location.origin}/assets/styles/tradingview/styles.css`;
    cssLink.rel = 'stylesheet';
    cssLink.type = 'text/css';

    if (iframe && iframe.contentDocument) {
      iframe.contentDocument.head.appendChild(cssLink);
      iframeHtmlElement = iframe.contentDocument.documentElement;
    }

    if (iframeHtmlElement) {
      const bodyStyles = window.getComputedStyle(document.body);
      const primaryColorLight = bodyStyles.getPropertyValue('--color-light-primary').trim();
      const primaryColorDark = bodyStyles.getPropertyValue('--color-dark-primary').trim();

      iframeHtmlElement.style.setProperty('--color-light-primary', primaryColorLight);
      iframeHtmlElement.style.setProperty('--color-dark-primary', primaryColorDark);
    }
  }

  changeChartTheme(themeId: number) {
    if (themeId === 0) {
      return;
    }
    // TODO: Desabilitado fundo branco padrão do tema
    // const bodyStyles = window.getComputedStyle(document.body);
    // const bgColor = bodyStyles.getPropertyValue(`--color-${newThemeMode.toLocaleLowerCase()}-candlestick-bg`).trim();
    // const newThemeProperties = {
    //   'paneProperties.background': bgColor,
    //   'scalesProperties.backgroundColor': bgColor
    // };
    // this._tvWidget.applyOverrides(newThemeProperties);
    const newThemeMode = themeId === 1 ? 'Dark' : 'Light';
    this._tvWidget.changeTheme(newThemeMode);
  }

  getLanguageFromURL(): LanguageCode | null {
    const regex = new RegExp('[\\?&]lang=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null ? 'pt' : decodeURIComponent(results[1].replace(/\+/g, ' ')) as LanguageCode;
  }

  loadChart() {
    const tempSymbol = this._symbol.trim() === '' ? ' ' : this._symbol.toUpperCase().trim();
    let params = `charts?user=${this._userId}&chart=${tempSymbol}`;
    if (!this.configService.getUserMarketData() && this._usersbrokerName) {
      params += `&broker=${this._usersbrokerName}`;
    }
    const isTokenUserMultiBroker = this.configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS && this.configService.getInfoUserLogged() ? true : false;
    if (tempSymbol.trim() !== '') {
      this._httpService.doGet(this._saveChartUrl, params, null, isTokenUserMultiBroker)
        .subscribe(res => {
          this.firstSymbolChange = true;
          this._newlyChangedSymbol = false;
          if (res.data && res.data.content && (typeof res.data.content === 'string')) {
            this._chartLastStatus = JSON.parse(res.data.content);
            this._validActive = true;
            if (this._chartLastStatus.charts[0]
              && this._chartLastStatus.charts[0].panes[0]
              && this._chartLastStatus.charts[0].panes[0].sources[0]
              && this._chartLastStatus.charts[0].panes[0].sources[0].state
              && this._chartLastStatus.charts[0].panes[0].sources[0].state.interval) {
              this._interval = this._chartLastStatus.charts[0].panes[0].sources[0].state.interval;

            } else {
              this._interval = Constants.DEFAULT_INTERVAL;
            }
          } else {
            this._validActive = false;
            this._chartLastStatus = null;
            this._interval = Constants.DEFAULT_INTERVAL;
            if (res.error || res._isScalar === false) {
              this.configService.systemNotificationMessage('', Constants.BROKER_MSG014, Constants.ALERT_TYPE.error);
            }
          }
          const chartInformation = this.configService.getSymbolInformation();
          if (chartInformation && typeof (chartInformation) === 'string') {
            const chartInfoParsed = JSON.parse(chartInformation);
            if (chartInfoParsed && chartInfoParsed.length > 0) {
              const currentChart = chartInfoParsed.filter(x => x.chartId === this._containerId)[0];
              if (currentChart && currentChart.symbolName !== undefined && currentChart.symbolName !== null) {
                currentChart.symbolName = tempSymbol.toUpperCase();
                this.configService.setSymbolInformation(currentChart);
              }
            }
          }
          this.createChartConfig();
        }, () => {
          this.configService.systemNotificationMessage('', Constants.BROKER_MSG014, Constants.ALERT_TYPE.error);
        });
    } else {
      this._validActive = false;
      this._chartLastStatus = null;
      this._symbol = tempSymbol ? tempSymbol : Constants.BLANK_CHART;
      this._interval = Constants.DEFAULT_INTERVAL;
      this.createChartConfig();
    }
  }

  saveChart() {
    if (this._firstLoad) {
      this._firstLoad = false;
      return;
    }
    if (this._newlyChangedSymbol) {
      return;
    }

    const isTokenUserMultiBroker = this.configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS && this.configService.getInfoUserLogged() ? true : false;
    let params = `charts?user=${this._userId}`;
    if (this._usersbrokerName && !isTokenUserMultiBroker) {
      params += `&broker=${this._usersbrokerName}`;
    }

    if (!this._tvWidget) {
      return;
    }
    this._tvWidget.save(status => {
      this._httpService.doPost(this._saveChartUrl, params, { symbol: this._symbol.toUpperCase(), content: JSON.stringify(status) }, null, null, isTokenUserMultiBroker)
        .subscribe(res => {
          if (res.error || res._isScalar === false) {
            this.configService.systemNotificationMessage('', Constants.BROKER_MSG014, Constants.ALERT_TYPE.error);
          }
        }, () => {
          this.configService.systemNotificationMessage('', Constants.BROKER_MSG014, Constants.ALERT_TYPE.error);
        });
    });
  }

  ngOnDestroy() {
    this.configService.deleteSymbolInformation(this._containerId);
    const resolution = this._tvWidget && this._tvWidget.chart() && this._tvWidget.chart().resolution() ?
    this._tvWidget.chart().resolution() : this._interval;
    this._chartService.unsubscribeChart(this._symbol, resolution);
    if (this._tvWidget !== null) {
      this._tvWidget.remove();
      this._tvWidget = null;
    }
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
